module.exports = __webpack_public_path__ + "public/img/logo_kariermu.38c93e95.svg";